module.exports = __webpack_public_path__ + "img/about_zhCn.063d90b4.png";